import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs';
import connect from "react-redux/es/connect/connect";
import {REQUEST_SITEMAP_DATA} from "../actions/sitemapActions";

const mapStateToProps = state => {
    return {
        sitemapData: state.sitemapData
    }
};

const mapDispatchToProps = dispatch => ({
    getSitemapData: () => dispatch({type: REQUEST_SITEMAP_DATA})
});

class Sitemap extends Component {

    componentDidMount() {
        if (!this.props.sitemapData.sitemap) {
            this.props.getSitemapData();
        }
    }

    render() {
        console.log(this.props.sitemapData.sitemap);

        return(
                <div className="wrapper mb36">
                    <Breadcrumbs pageTitle="Sitemap" />
                    <h1 className="sitemap-heading mbl">Sitemap</h1>
                    <div className="sitemap-container mtl">

                        {
                            this.props.sitemapData.sitemap ?
                                    this.props.sitemapData.sitemap.map((row) =>
                                            <div className="sitemap-row mtl">
                                                <h2>{row.rowTitle}</h2>
                                                {
                                                    row.sections ?
                                                    row.sections.map((section) => (
                                                            <React.Fragment>
                                                                <h3 className="mtm">
                                                                    {
                                                                        section.title === "Flight Status" ? <a href={section.link.value}>{section.title}</a> : <NavLink to={section.link.value}>{section.title}</NavLink>
                                                                    }

                                                                </h3>
                                                                {
                                                                    section.subsections ?
                                                                            section.subsections.map((subsection) => (
                                                                                    <ul>
                                                                                        <li>
                                                                                            <NavLink to={subsection.link.value}>{subsection.title}</NavLink>
                                                                                        </li>
                                                                                    </ul>
                                                                            ))
                                                                            : null
                                                                }
                                                            </React.Fragment>

                                                    ))
                                                            : null
                                                }

                                            </div>

                                    )
                                    : null
                        }




                    </div>
                </div>
        )
    }
}

export default (connect(mapStateToProps, mapDispatchToProps)(Sitemap));



// WEBPACK FOOTER //
// ./src/pages/Sitemap.js